module.exports = __webpack_public_path__ + "static/media/venus-1.6918200b.jpg";